import React from 'react'
import { FilterTagList } from 'src/components/FilterTags/FilterTagList'
import { IS_BLACK_FRIDAY } from 'src/utils/globals'
import {
  ShowAllProductsButton,
  StCloseButton,
  StCloseButtonIcon,
  StCloseButtonIconWhite,
  StFilterSideBarMobile,
  StHeader,
  StTitle,
} from './styles'

export const FilterSideBarMobile = ({
  itemCount,
  typeFilterList,
  collectionFilterList,
  sizeFilterList,
  colorFilterList,
  promotionsFilterList,
  isOpen,
  setIsOpen,
  allFilterValues,
  clearAllFilters,
  removeFilterValue,
}) => {
  return (
    <StFilterSideBarMobile isOpen={isOpen}>
      <StHeader>
        <StTitle>Filter</StTitle>
        <StCloseButton onClick={() => setIsOpen(false)}>
          {IS_BLACK_FRIDAY ? <StCloseButtonIconWhite /> : <StCloseButtonIcon />}
        </StCloseButton>
      </StHeader>
      {allFilterValues.length > 0 && (
        <div
          style={{
            marginLeft: '12px',
            marginRight: '15px',
            marginTop: '15px',
            marginBottom: '0.5em',
            borderBottom: '1px solid #3331314d',
          }}
        >
          <FilterTagList
            filterValues={allFilterValues}
            clearAll={clearAllFilters}
            onRemove={removeFilterValue}
            inGrid={false}
          />
        </div>
      )}
      {typeFilterList}
      {collectionFilterList}
      {sizeFilterList}
      {colorFilterList}
      {promotionsFilterList}
      <ShowAllProductsButton onClick={() => setIsOpen(false)}>
        Show {itemCount} Products
      </ShowAllProductsButton>
    </StFilterSideBarMobile>
  )
}
